import React, { useEffect, useState } from 'react';
import { StatsBignumbers } from '../../components/Dashboard/StatsBignumbers';
import { RecentDocuments } from '../../components/Dashboard/RecentDocuments';
import { ProcessingStatus } from '../../components/Dashboard/ProcessingStatus';
import { JobsStatusWidget } from '../../components/Dashboard/JobsStatusWidget';
import { StatusConsolidationMessage } from '../../components/Dashboard/StatusConsolidationMessage';
import { LoggedUsers } from '../../components/Dashboard/LoggedUsers';
import { DocumentsByStatus } from '../../components/Dashboard/DocumentsByStatus';

// Exemplo de perfil: 'admin', 'gestor', 'padrao'
const userProfile = 'admin';

export const DashboardPage: React.FC = () => {
  const [isAdmin, setIsAdmin] = useState<boolean>(true);
  const [isManager, setIsManager] = useState<boolean>(true);
  
  // Em um cenário real, isso seria determinado pelo login do usuário
  useEffect(() => {
    // Simulando verificação de perfil do usuário
    // Em produção, isso seria obtido do contexto de autenticação
    const checkUserRole = () => {
      if (userProfile === 'admin') {
        setIsAdmin(true);
        setIsManager(true);
      } else if (userProfile === 'gestor') {
        setIsAdmin(false);
        setIsManager(true);
      } else {
        setIsAdmin(false);
        setIsManager(false);
      }
    };
    
    checkUserRole();
  }, []);
  return (
    <div className="flex-1">
          <div className="mb-6">
            <h1 className="text-2xl font-bold mb-2">Dashboard</h1>
            <p className="text-gray-600">Bem-vindo ao Sistema Know inDoc. Gerencie seus documentos com processamento inteligente da Baruk.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <StatsBignumbers />
            <RecentDocuments />
            <ProcessingStatus />
          </div>
          
          {/* Informações estratégicas para gerentes e administradores */}
          {(isManager || isAdmin) && (
            <div className="mb-6">
              <h2 className="text-xl font-semibold mb-4">Informações Estratégicas</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                <DocumentsByStatus />
                <StatusConsolidationMessage />
                <LoggedUsers />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                <JobsStatusWidget />
              </div>
            </div>
          )}
          
          {/* Componentes RecentDocuments e ChatInDoc foram removidos */}
    </div>
  );
};